import { Route, Routes, Link } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Characters from "./Character";
import Location from "./components/Location";
import Error from "./components/404";

export default function App() {
 return (
  <div className="App">
   <Navbar />
   <Routes>
    <Route index element={<Characters />} />
    <Route path="/rick-and-morty" element={<Characters />} />
    <Route path="/rick-and-morty/Characters" element={<Characters />} />
    <Route path="/rick-and-morty/Location" element={<Location />} />
    <Route path="*" element={<Error />} />
   </Routes>
   <Footer />
  </div>
 );
}